/**
 * @generated SignedSource<<518626a4e08b6781d23d4737dfa2e750>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRecentSalesOverview_creatorRootTransactions$data = {
  readonly averageSoldPrice: number | null;
  readonly maxPrice: number | null;
  readonly minPrice: number | null;
  readonly " $fragmentType": "SbSharedRecentSalesOverview_creatorRootTransactions";
};
export type SbSharedRecentSalesOverview_creatorRootTransactions$key = {
  readonly " $data"?: SbSharedRecentSalesOverview_creatorRootTransactions$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRecentSalesOverview_creatorRootTransactions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRecentSalesOverview_creatorRootTransactions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "averageSoldPrice",
      "storageKey": null
    }
  ],
  "type": "CreatorRootTransactions",
  "abstractKey": null
};

(node as any).hash = "74940f6d72e914de4dbc7c5a42cca373";

export default node;
